export interface Destination {
  id: string
  title: string
  shortTitle?: string
  description: string
  heroImage: string
  link: string
  region: string
  season: string
}

export const destinations: Destination[] = [
  {
    id: 'la-parva',
    title: 'La Parva Ski Resort',
    shortTitle: 'La Parva',
    description: 'Premium ski resort in the heart of the Andes, offering world-class runs and breathtaking views just 40 minutes from Santiago.',
    heroImage: '/images/la-parva-ski-village-optimized.webp',
    link: '/destinations/la-parva',
    region: 'Central Andes',
    season: 'Winter'
  },
  {
    id: 'farellones',
    title: 'Farellones Mountain Village',
    shortTitle: 'Farellones',
    description: 'A charming mountain village offering a perfect blend of adventure and relaxation, with access to multiple ski resorts.',
    heroImage: '/images/farellones-andes-mountain-chile.webp',
    link: '/destinations/farellones',
    region: 'Central Andes',
    season: 'Year-Round'
  },
  {
    id: 'patagonia',
    title: 'Chilean Patagonia',
    shortTitle: 'Patagonia',
    description: 'Remote wilderness adventures in one of the world\'s most pristine regions, featuring fly fishing, trekking, and helicopter tours.',
    heroImage: '/images/yelcho-lake-patagonia-fly-fishing.webp',
    link: '/destinations/patagonia',
    region: 'Southern Chile',
    season: 'Summer'
  },
  {
    id: 'lake-district',
    title: 'Lake District',
    shortTitle: 'Lake District',
    description: 'Explore volcanic landscapes, pristine lakes, and native forests in Chile\'s stunning Lake District region.',
    heroImage: '/images/pucon.webp',
    link: '/destinations/lake-district',
    region: 'Araucanía',
    season: 'Summer'
  },
  {
    id: 'coastal-vineyards',
    title: 'Coastal Wine Valleys',
    shortTitle: 'Wine Valleys',
    description: 'Helicopter tours to Chile\'s renowned wine valleys, combining world-class wines with Pacific Ocean views.',
    heroImage: '/images/adventures/water-skiing/water-skiing-hero-1280.webp',
    link: '/destinations/wine-valleys',
    region: 'Central Coast',
    season: 'Year-Round'
  },
  {
    id: 'atacama-desert',
    title: 'Atacama Desert',
    shortTitle: 'Atacama',
    description: 'Experience the world\'s driest desert with otherworldly landscapes, salt flats, and stargazing opportunities.',
    heroImage: '/images/hero-poster.webp',
    link: '/destinations/atacama',
    region: 'Northern Chile',
    season: 'Year-Round'
  }
]

export function getDestinationById(id: string): Destination | undefined {
  return destinations.find(dest => dest.id === id)
}

export function getDestinationHeroImages(): string[] {
  return destinations.map(dest => dest.heroImage)
}

export function getDestinationsByRegion(region: string): Destination[] {
  return destinations.filter(dest => dest.region === region)
}

export function getDestinationsBySeason(season: string): Destination[] {
  return destinations.filter(dest => dest.season === season || dest.season === 'Year-Round')
}
